export const BILLINGS_VIEW_PATH = "/billings";
export const ON_DEMAND_BILLING_PATH = "/billings/on-demand";
